import './PanelHeader.css';

const PanelHeader = ({ collapsed, isGenerating, hasSpawnPosition, onResetSpawn, insightsOpen, onToggleInsights, hasMessages, onNewSession, onToggleCollapsed, onClose, onMouseDown, onClick }) => (
    <div className="ai_chat_panel_header" onMouseDown={onMouseDown} onClick={onClick} title={collapsed ? "Click to open Teia.AI · drag to move" : "Drag to move · click to shrink"}>
        <div className="ai_chat_panel_title">
            <span className={"ai_chat_panel_dot" + (isGenerating ? " working" : "")}></span>
            <span>Teia — AI Bot Builder</span>
        </div>
        <div className={"ai_chat_panel_chip" + (isGenerating ? " working" : "")}>
            <span className="ai_chat_panel_chip_icon" aria-hidden="true">
                <span className="ai_chat_panel_chip_star"></span>
                <span className="ai_chat_panel_chip_star small"></span>
            </span>
            <span>Teia.AI</span>
        </div>
        <div className="ai_chat_panel_header_actions" onClick={(e) => e.stopPropagation()}>
            {hasSpawnPosition &&
                <i className="fas fa-crosshairs" title="Re-center the generation marker" onClick={onResetSpawn}></i>
            }
            <i
                className={"fas fa-info-circle" + (insightsOpen ? " active" : "")}
                title="Teia insights: AI usage, JSON response and history"
                onClick={onToggleInsights}
            ></i>
            {hasMessages &&
                <i className="fas fa-undo" title="New session" onClick={onNewSession}></i>
            }
            <i className="fas fa-chevron-down ai_chat_panel_chevron" title="Shrink to a small square" onClick={onToggleCollapsed}></i>
            <i className="fas fa-times" title="Close (the conversation stays in memory)" onClick={onClose}></i>
        </div>
    </div>
);

export default PanelHeader;
